import {Search} from '@carbon/icons-react';
import {InputAdornment, TextField} from '@mui/material';
import React from 'react';
type handleDocumentSearch = {
  handleDocumentSearch: (arg0: string) => void;
};
export const ArtifactSearch = ({handleDocumentSearch}: handleDocumentSearch) => {
  const [docQuery, setDocQuery] = React.useState<string>('');

  const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key == 'Enter') {
      handleDocumentSearch(docQuery);
    }
  };
  return (
    <TextField
      variant='outlined'
      size='small'
      sx={{width: '400px', borderRadius: '6px'}}
      InputProps={{
        startAdornment: (
          <InputAdornment position='start'>
            <Search color='black' />
          </InputAdornment>
        ),
      }}
      placeholder={'Search Process Resources'}
      onChange={(e) => setDocQuery(e.target.value)}
      onKeyDown={handleKeyDown}
    />
  );
};
